import { useGetSocialBets } from 'src/store/social'
import { useDeviceInfo } from 'src/hooks/useDeviceInfo'
import { getSpeedByAmount } from '../utils/getSpeedByAmount'
import { AnimatedSocialBet } from './components/AnimatedSocialBet'
import { SocialBetItem } from './components/SocialBetItem'

export function AnimatedSocialBetStream() {
  const bets = useGetSocialBets()
  const { isMobile } = useDeviceInfo()
  const dimensions = isMobile ? { width: 100, height: 100 } : { width: 200, height: 150 }

  return (
    <div className="social-bet-stream__animated">
      <div className="social-bet-stream__container" style={{ height: `${dimensions.height}px` }}>
        {bets.map((bet, index) => (
          <AnimatedSocialBet
            heightAnimation={dimensions.height}
            index={index}
            key={bet.id}
            betId={bet.id}
            speed={getSpeedByAmount(bet.betAmount)}
            widthAnimation={dimensions.width * 0.8}
          >
            <SocialBetItem bet={bet} />
          </AnimatedSocialBet>
        ))}
      </div>
    </div>
  )
}
